import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import './custom.css';
import { TicTacToe } from "./components/TicTacToe/Game";
import { FetchData } from "./components/FetchData";
import { Dashboard } from "./components/Dashboard";
import { AboutMe } from "./components/AboutMe";
import { Domotica } from "./components/Domotica";
import { Login } from "./components/Login";
import { AuthProvider, ProtectedRoute } from "./components/AuthContext";

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <AuthProvider>
                <Routes>
                    <Route path="/login" default element={<Login />} />
                    <Route index path="/" element={<Dashboard />} />
                    <Route index path="/aboutme" element={<AboutMe />} />
                    <Route path="/tictactoe" default element={<TicTacToe />} />
                    <Route path="/fetch-data" default element={<FetchData />} />
                    <Route path="/domotica" element={
                        <ProtectedRoute>
                            <Domotica />
                        </ ProtectedRoute>
                    } />
                    <Route path="*" element={
                        <ProtectedRoute>
                        <Domotica />
                    </ ProtectedRoute>} />
                </Routes>
            </AuthProvider>
        );
    }
}
